import { CallbacksPool } from './CallbacksPool';

interface Unsubscribe {
  (): void;
}

export class CallbacksMap<TKey, TPayloadType extends any[] = []> {
  private readonly _map = new Map<TKey, CallbacksPool<TPayloadType>>();

  private readonly _getPoolOrCreate = (key: TKey) => {
    const pool = this._map.get(key);

    if (pool) {
      return pool;
    } else {
      const newPool = new CallbacksPool<TPayloadType>();

      this._map.set(key, newPool);

      return newPool;
    }
  };

  sizeOf = (key: TKey) => this._map.get(key)?.size || 0;

  size = () => Array.from(this._map.values()).reduce((acc, callbacks) => acc + callbacks.size, 0);

  set = (key: TKey, callback: (...payload: TPayloadType) => void): Unsubscribe => {
    this._getPoolOrCreate(key).add(callback);

    return () => this.remove(key, callback);
  };

  remove = (key: TKey, callback: (...payload: TPayloadType) => void) => {
    const pool = this._map.get(key);

    if (pool) {
      pool.remove(callback);

      if (pool.size === 0) {
        this.clearByKey(key);
      }
    }
  };

  invoke = (key: TKey, ...payload: TPayloadType) => {
    const pool = this._map.get(key);

    if (pool) {
      pool.invoke(...payload);
    }
  };

  clearByKey = (key: TKey) => {
    this._map.delete(key);
  };

  clear = () => {
    this._map.clear();
  };
}
